module.exports = __webpack_public_path__ + "static/media/Thankful.96beea1d.jpg";